module.exports = __webpack_public_path__ + "static/media/white_red5.d7612f6e.jpg";